/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
 */
export interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    external_ehr_document_id?: string;
    /**
     * 
     */
    relation_type?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum;
    /**
     * 
     */
    relation_id?: string;
    /**
     * 
     */
    created_at?: string;
}


/**
 * @export
 */
export const CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum = typeof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum[keyof typeof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum];


/**
 * Check if a given object implements the CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument interface.
 */
export function instanceOfCreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument(value: object): value is CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    return true;
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json: any): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    return CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'external_ehr_document_id': json['external_ehr_document_id'] == null ? undefined : json['external_ehr_document_id'],
        'relation_type': json['relation_type'] == null ? undefined : json['relation_type'],
        'relation_id': json['relation_id'] == null ? undefined : json['relation_id'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(json: any): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    return CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSONTyped(value?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'type': value['type'],
        'external_ehr_document_id': value['external_ehr_document_id'],
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
        'created_at': value['created_at'],
    };
}

